import { render, staticRenderFns } from "./promocodes.vue?vue&type=template&id=a5b49216"
import script from "./promocodes.vue?vue&type=script&lang=ts"
export * from "./promocodes.vue?vue&type=script&lang=ts"
import style0 from "./promocodes.vue?vue&type=style&index=0&id=a5b49216&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports